import Vue from "vue"
import VueRouter from "vue-router"
import routes from './routes'
Vue.use(VueRouter)


const router = new VueRouter({
    mode: "history",
    routes
})
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace (location) {
    return originalReplace.call(this, location).catch(err => err)
}
router.afterEach(() => {
    window.scrollTo({
        top: 0,
        behavior: "instant"
    })
})

// SEO：更新或创建 head 中的 meta 标签
function setMeta (name, content, attr = 'name') {
    if (!content) return
    let el = document.head.querySelector(`meta[${attr}="${name}"]`)
    if (!el) {
        el = document.createElement('meta')
        el.setAttribute(attr, name)
        document.head.appendChild(el)
    }
    el.setAttribute('content', content)
}

// SEO：更新规范网址 canonical
function setCanonical (url) {
    let el = document.head.querySelector('link[rel="canonical"]')
    if (!el) {
        el = document.createElement('link')
        el.setAttribute('rel', 'canonical')
        document.head.appendChild(el)
    }
    el.setAttribute('href', url)
}

router.beforeEach((to, from, next) => {
    // 标题
    if (to.meta && to.meta.title) {
        document.title = to.meta.title
    }

    // SEO：description / keywords（同时支持搜索引擎与社交分享）
    if (to.meta) {
        if (to.meta.description) {
            setMeta('description', to.meta.description)
            setMeta('og:description', to.meta.description, 'property')
            setMeta('twitter:description', to.meta.description)
        }
        if (to.meta.keywords) {
            setMeta('keywords', to.meta.keywords)
        }
        if (to.meta.title) {
            setMeta('og:title', to.meta.title, 'property')
            setMeta('twitter:title', to.meta.title)
        }
    }

    // SEO：canonical 与 og:url（依赖当前 origin，便于多域名部署）
    try {
        const canonical = window.location.origin + to.fullPath
        setCanonical(canonical)
        setMeta('og:url', canonical, 'property')
    } catch (e) {
        // ignore
    }

    // 标记当前路由是否为隐私政策或用户协议页面
    const isPrivacyOrAgreementPage = to.path === '/privacy' || to.path === '/privacy-policy'
    // 将标记存储到路由的 meta 中，供 App.vue 使用
    to.meta.skipApiCalls = isPrivacyOrAgreementPage

    next()
})
export default router
